import {Component, ViewChild, OnInit, TemplateRef, EventEmitter, Output } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { ModalService } from '../../../services/modal.service';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TipoMediador } from '../../../model/tipomediador';
import { CadastrosService } from '../../../services/cadastros.service';

@Component({
  selector: 'app-detalhes-tipomediador',
  templateUrl: 'tipomediador-detalhes.component.html'
})
export class TipoMediadorDetalhesComponent implements OnInit{

  @ViewChild('modaltipomediador', {static: false}) public modaltipomediador: ModalDirective;

  sub: boolean = false;
  _tipomediador: TipoMediador = new TipoMediador();
  @Output() loadtipomediador = new EventEmitter();
  titulo: string = "Novo Tipo de Mediador";
  movSubSalvar: Subscription;
  movSubAlterar: Subscription;
  movSub: Subscription;

  constructor(
    private modalService: ModalService,
    private toastr: ToastrService,
    private cadastrosService: CadastrosService) {
  }

  ngOnInit() {

    if(this.sub == false){

      this.sub = true;

      this.modalService.modalDetalhesTipoMediador.subscribe(
        (p: TipoMediador) => {

          if(p == null){
            this.titulo = "Novo Tipo de Mediador"
            this._tipomediador = new TipoMediador();
          }else{
            this.titulo = "Editar Tipo de Mediador"
            this._tipomediador = p;
          }

          this.limpaModal();

          this.modaltipomediador.show();

        }, error => {
          console.log(error.message);
        }
      );
    }

  }

  hideModal(){
    this.modaltipomediador.hide();
    this.loadtipomediador.emit();
  }

  limpaModal(){
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  onSubmit(form: NgForm) {

    if (!form.valid) {
      return;
    }

    if(this.titulo == "Editar Tipo de Mediador"){
      this.atualizar();
    }else{
      this.salvar();
    }

    form.reset();
  }

  salvar(){

    let objtipomediador = JSON.parse(JSON.stringify(this._tipomediador));

    this.cadastrosService.salvar("tipomediador/insert", objtipomediador).subscribe(
      (result) =>{

        this.toastr.success('Tipo de Mediador cadastrado com sucesso!', 'Sucesso!');
        console.log(result);

        this.hideModal();

      },
      error=> {

        this.toastr.error(error.message, 'Erro!');
        console.log(error);

        this.hideModal();
      }

    );



  }

  atualizar(){

    let objtipomediador = JSON.parse(JSON.stringify(this._tipomediador));

    this.cadastrosService.atualizar("tipomediador/update", objtipomediador, objtipomediador.id).subscribe(
      (result) =>{

        this.toastr.success('Tipo de Mediador atualizado com sucesso!', 'Sucesso!');
        console.log(result);

        this.hideModal();

      },
      error=> {

        this.toastr.error(error.message, 'Erro!');
        console.log(error);

        this.hideModal();
      }

    );
  }
}
